import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import FormRequestForm from 'Components/FormRequestsForm';
import { PlanTypes } from 'Interfaces/Billing';
import { DocumentStatuses, DocumentTypes } from 'Interfaces/Document';
import { AuthorizedRoutePaths, settingsRedirectionMap } from 'Interfaces/RoutePaths';
import { User } from 'Interfaces/User';
import { selectUser, selectUserPlan } from 'Utils/selectors';

function FormRequestCreate() {
  const navigate = useNavigate();
  const userPlan = useSelector(selectUserPlan);
  const user = useSelector(selectUser) as User;

  useEffect(() => {
    if (userPlan.type !== PlanTypes.BUSINESS && !user.teamId) {
      navigate(settingsRedirectionMap[AuthorizedRoutePaths.SETTINGS_BILLING_PLAN]);
    }
  }, [navigate, user.teamId, userPlan.type]);

  return (
    <FormRequestForm
      initialValues={{
        type: DocumentTypes.FORM_REQUEST,
        status: DocumentStatuses.DRAFT,
        signers: [
          { isPreparer: true, order: -1, role: 'Me (Now)' },
          { order: 0, role: 'SIGNER' },
        ],
      }}
    />
  );
}

export default FormRequestCreate;
